export const ChatListingTypes = {
  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
  TRANSFERRED: "TRANSFERRED",
};

export const ConversationStatus = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  AUTO_CLOSURE: "AUTO_CLOSURE",
  TRANSFERRED: "TRANSFERRED",
};
